// extracted by mini-css-extract-plugin
export var lightMode = "_19-0";